/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_InboundInputs */

const cs_settings_calendar_inbound = /** @type {(inputs: Settings_Calendar_InboundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importovat busy bloky z tohoto kalendáře`)
};

const en_settings_calendar_inbound = /** @type {(inputs: Settings_Calendar_InboundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import busy blocks from this calendar`)
};

/**
* | output |
* | --- |
* | "Import busy blocks from this calendar" |
*
* @param {Settings_Calendar_InboundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_inbound = /** @type {((inputs?: Settings_Calendar_InboundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_InboundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_inbound(inputs)
	return cs_settings_calendar_inbound(inputs)
});